import { withTheme, withStyles, IconButton } from "@material-ui/core";
import React from "react";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import {
  GeoCode,
  MapAutoZoom,
  MapLegendToggle,
  Resize,
  Popout,
} from "../../../../../../layout/layoutHeader/components";
import MapDrawinToolBox from "../../../../../mapComponents/Drawing/DrawingToolbox";
import DriverMapStopFilter from "./MapStopFilter";
import MoreVert from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import Tooltip from "../../../../../common/StyledToolTip";
import ShowAllDrivers from "../../ShowAllDrivers";
import ShowDriverLabel from "../../ShowDriverLabel";
import ExpandDriverStopList from "../../ExpandDriverStopList";
import ShowOnHoverPopup from "../../ShowOnHoverPopup";
import { observer, inject } from "mobx-react";
import { getDriverMapConfig } from "../utils";
import { SavePreferences } from "../../../../../../utilities/appHelper";
import constants from "../../../../../../appConstants";
import MapViews from "../../../../../mapComponents/MapViews";
import { withAppConfig } from "../../../../../../appConfigContext";
import WatchTutorial from "../../../../../InAppTutorial/WatchTutorial";

const styles = (theme) => ({
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "30px",
    overflow: "inherit",
  },
  mainMenuStyle: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 0px",
    width: "220px",
  },
  toggledMenu: {
    display: "inline",
  },
  mainMenuButton: {
    padding: "9px",
    color: theme.HeaderSelectedText,
  },
});

@inject("DispatchStore")
@observer
class MapHeader extends React.Component {
  constructor(props) {
    super(props);
    const driversMapConfig = getDriverMapConfig(
      this.props.userData.userProfile?.columnPref
    );
    this.props.DispatchStore.setShowAllDrivers(
      driversMapConfig.toggles.isShowAllDriversEnabled
    );
    this.props.DispatchStore.setShowDriverLabel(
      Boolean(driversMapConfig.toggles.isShowDriverLabelEnabled)
    );
    this.props.DispatchStore.setExpandDriverStopList(
      Boolean(driversMapConfig.toggles.isExpandDriverStopListEnabled)
    );
    this.props.DispatchStore.setShowOnHoverPopup(
      Boolean(driversMapConfig.toggles.isShowOnHoverPopupEnabled)
    );
    this.state = {
      mainMenuAnchor: null,
      isMapLegendEnabled: driversMapConfig.toggles.isMapLegendEnabled,
      isRouteAnimationEnabled: driversMapConfig.toggles.isRouteAnimationEnabled,
    };
  }

  saveDriverMapConfig = ({ mapName, config }) => {
    let { columnPref, userId } = this.props.userData.userProfile;
    if (!columnPref) {
      columnPref = {};
    }
    let storedConfig = columnPref[`${mapName}_Config`]?.toggles ?? {};
    SavePreferences({
      name: `${mapName}_Config`,
      config: { toggles: { ...storedConfig, ...config } },
      userColumnPref: columnPref,
      userId,
    });
  };

  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };
  toggleMapLegend = (value) => {
    this.setState({
      isMapLegendEnabled: value,
    });
    this.saveDriverMapConfig({
      mapName: constants.mapName.DispatchMap,
      config: { isMapLegendEnabled: value },
    });
  };
  toggleRouteAnimation = (value) => {
    this.setState({
      isRouteAnimationEnabled: value,
    });
    this.saveDriverMapConfig({
      mapName: constants.mapName.DispatchMap,
      config: { isRouteAnimationEnabled: value },
    });
  };

  toggleShowAllDrivers = () => {
    this.props.DispatchStore.setShowAllDrivers(
      !this.props.DispatchStore.showAllDrivers
    );
    this.saveDriverMapConfig({
      mapName: constants.mapName.DispatchMap,
      config: {
        isShowAllDriversEnabled: this.props.DispatchStore.showAllDrivers,
      },
    });
  };

  toggleShowDriverLabel = () => {
    const showDriverLabel = !this.props.DispatchStore.showDriverLabel;
    this.props.DispatchStore.setShowDriverLabel(showDriverLabel);
    this.saveDriverMapConfig({
      mapName: constants.mapName.DispatchMap,
      config: {
        isShowDriverLabelEnabled: showDriverLabel
      }
    });
  };

  toggleExpandDriverStopList = () => {
    const expandDriverStopList = !this.props.DispatchStore.expandDriverStopList;
    this.props.DispatchStore.setExpandDriverStopList(expandDriverStopList);
    this.saveDriverMapConfig({
      mapName: constants.mapName.DispatchMap,
      config: {
        isExpandDriverStopListEnabled: expandDriverStopList
      }
    });
  };

  toggleShowOnHoverPopup = () => {
    const showOnHoverPopup = !this.props.DispatchStore.showOnHoverPopup;
    this.props.DispatchStore.setShowOnHoverPopup(showOnHoverPopup);
    this.saveDriverMapConfig({
      mapName: constants.mapName.DispatchMap,
      config: {
        isShowOnHoverPopupEnabled: showOnHoverPopup
      }
    });
  };

   render() {
    const { mainMenuAnchor } = this.state;
    const { classes, DispatchStore, ...other } = this.props;
    return (
      <div>
        {this.props.configJSON?.maps?.enableTrafficWeatherLayer ? (
          <MapViews            
            eventHub={this.props.stack.layoutManager.eventHub}
            mapId={"dispatchMap"}
            trafficWeatherVisibility
          />
        ) : null}

        <DriverMapStopFilter
          {...other}
          userData={this.props.userData}
          priorityShipmentList={DispatchStore.priorityShipmentList}
          stopsFilter={DispatchStore.stopsFilter}
        />
        <MapDrawinToolBox measureTool lasso delete />
        <GeoCode {...other} />
        <Resize {...other} />
        <Popout {...other} />
        <div className={classes.toggledMenu}>
          <IconButton
            color="inherit"
            className={classes.mainMenuButton}
            onClick={this.openMainMenu}
          >
            <Tooltip title="Show Controls">
              <MoreVert style={{ fontSize: "21px" }} />
            </Tooltip>
          </IconButton>
        </div>
        <div>
          <Menu
            disablePortal
            getContentAnchorEl={null}
            disableAutoFocusItem
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(mainMenuAnchor)}
            keepMounted
            anchorEl={mainMenuAnchor}
            onClose={this.closeMainMenu}
            MenuListProps={{ disablePadding: true }}
            classes={{
              paper: classes.mainMenu,
            }}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <div className={classes.mainMenuStyle}>
              <WatchTutorial showLabel componentId={constants.mapName.DispatchMap}/>
              <MapAutoZoom
                isEnabled={this.state.isRouteAnimationEnabled}
                isMenuItem
                toggleRouteAnimation={this.toggleRouteAnimation}
                {...other}
                eventHub={this.props.stack.layoutManager.eventHub}
                title={"Enable/Disable Map Zoom"}
              />
              <MapLegendToggle
                isMapLegendEnabled={this.state.isMapLegendEnabled}
                isMenuItem
                toggleMapLegend={this.toggleMapLegend}
                {...other}
              />
              <ShowAllDrivers
                isEnabled={DispatchStore.showAllDrivers}
                isMenuItem
                toggleShowAllDrivers={this.toggleShowAllDrivers}
                {...other}
              />
              <ShowDriverLabel
                isEnabled={DispatchStore.showDriverLabel}
                isMenuItem
                toggleShowDriverLabel={this.toggleShowDriverLabel}
                {...other}
              />
               <ExpandDriverStopList
                isEnabled={DispatchStore.expandDriverStopList}
                isMenuItem
                toggleExpandDriverStopList={this.toggleExpandDriverStopList}
                {...other}
              />
               <ShowOnHoverPopup
                isEnabled={DispatchStore.showOnHoverPopup}
                isMenuItem
                toggleShowOnHoverPopup={this.toggleShowOnHoverPopup}
                {...other}
              />
            </div>
          </Menu>
        </div>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withTheme(),
  withStyles(styles),
  withAppConfig
)(MapHeader);
